module.exports = __webpack_public_path__ + "img/logo.faa281c0.jpg";